import { useContext } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { BreakpointContext } from 'contexts/breakpoint/BreakpointContext';
import Icon from 'components/atoms/Icon/Icon';
import { ButtonQrScanProps } from './ButtonQrScan.types';
import { ButtonLabel, Wrapper } from './ButtonQrScan.styles';

export const ButtonQrScan: React.FC<ButtonQrScanProps> = ({ className, onClickCallback }) => {
  const { t } = useTranslation('common');

  const bp = useContext(BreakpointContext);
  const isMobile = bp === 'xs' || bp === 'sm';

  if (!isMobile) {
    return <></>;
  }
  return (
    <Wrapper onClick={onClickCallback} className={className}>
      <Icon name="QR_CODE" />
      <ButtonLabel>{t('buttonQrCode')}</ButtonLabel>
    </Wrapper>
  );
};
